(function() {
    'use strict';

    angular
        .module('app.layout')
        .controller('AppController', AppController);

    /*@ngInject*/
    function AppController($state, $stateParams, DOMAIN_UI, $anchorScroll, $location){
        var vm = this;
        vm.isFixedLayout = isFixedLayout;
        vm.class={skin: DOMAIN_UI.skin};
        vm.gotoAnchor = gotoAnchor;
        vm.setSeo = setSeo;
        vm.buildAbsoluteUrl = buildAbsoluteUrl;

        vm.setFavicon = setFavicon;

        function setFavicon(faviconLink){
            //set favicon
            vm.favicon = faviconLink;
        }

        function buildAbsoluteUrl(toState, params, locale){
            var locale = {language:locale};
            // if(toState){
            //     console.debug('!!!!!+', toState);
            //     return  $state.href(toState, params, {absolute: true})
            // }else{
                var logoutstate = $state.current.name;
                // console.debug('!!!!!',$state.current, logoutstate, params);
                return  $state.href(logoutstate, angular.extend({}, $stateParams, params, locale), {absolute: true})
            // }
        }

        function setSeo(data){
            if (!data){
                return;
            }

            if(!  vm.seo){
                vm.seo = {};
            }
            vm.seo.SEO_Description = data.SEO_Description;
            vm.seo.SEO_Keywords = data.SEO_Keywords;
            vm.seo.SEO_Title = data.SEO_Title;
            vm.seo.SEO_hreflang = data.SEO_hreflang;

            vm.favicon = data.faviconLink;

            console.log('SEO_UPDATE', vm.seo);
        }
        function setSkinClass(skin){
            if(skin){
                if(!  vm.class){
                    vm.class = {};
                }
                vm.class.skin = skin;
            }
        }
        function isFixedLayout(){
            return $state.includes('advisor') || $state.includes('advisor_w') || $state.includes('advisor_wl');
        }

        function gotoAnchor(x) {
            var newHash = 'anchor' + x;
            if ($location.hash() !== newHash) {
                // set the $location.hash to `newHash` and
                // $anchorScroll will automatically scroll to it
                $location.hash('anchor' + x);
            } else {
                // call $anchorScroll() explicitly,
                // since $location.hash hasn't changed
                $anchorScroll();
            }
        }
    }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/app.controller.js
 ** module id = 222
 ** module chunks = 0
 **/